import { render, staticRenderFns } from "./exchange-alert.vue?vue&type=template&id=2ee9f026&scoped=true&"
import script from "./exchange-alert.vue?vue&type=script&lang=js&"
export * from "./exchange-alert.vue?vue&type=script&lang=js&"
import style0 from "./exchange-alert.vue?vue&type=style&index=0&id=2ee9f026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9f026",
  null
  
)

export default component.exports